<template>
  <div id="accounts-payable-payment-orders">
    <BreadCrumb :items="breadcrumbItems" />
    <v-card elevation="1" class="pa-2">
      <v-card-title class="header d-flex justify-space-between align-center">
        <h1 class="pa-0">Ordens de Pagamento</h1>
        <div>
          <v-btn @click="handleExport" :loading="isExportButtonLoading" elevation="2" color="info" large>
            Exportar planilha</v-btn
          >
        </div>
      </v-card-title>
      <v-expansion-panels accordion class="mt-2 mb-10 px-4">
        <v-expansion-panel class="elevation-1">
          <v-expansion-panel-header color="#f2f2f2" class="px-4">
            <span>Filtrar por</span>
            <template v-slot:actions>
              <v-icon color="black"> mdi-chevron-down </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="mt-2 pb-1">
              <v-col cols="12" md="4" class="pb-0"> <h5>Data de Criação</h5></v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="4" class="pb-0"> <h5>Data de Previsão</h5></v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="4" class="pb-0"> <h5>Data de Pagamento</h5></v-col>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu
                  v-model="initialCreatedAtMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedInitialCreatedAt"
                      label="Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="initialCreatedAt" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu
                  v-model="endCreatedAtMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedEndCreatedAt"
                      label="Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="endCreatedAt" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu
                  v-model="initialForecastMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedInitialForecast"
                      label="Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="initialForecast" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu
                  v-model="endForecastMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedEndForecast"
                      label="Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="endForecast" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu
                  v-model="initialPaymentMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedInitialPayment"
                      label="Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="initialPayment" locale="pt-br"></v-date-picker>
                </v-menu> </v-col
              ><v-col cols="12" md="2" class="pt-0">
                <v-menu
                  v-model="endPaymentMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedEndPayment"
                      label="Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="endPayment" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="statusId"
                  :items="getSummaryStatus"
                  label="Status do Pagamento"
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="typeId"
                  :items="getSummaryTypes"
                  label="Tipo de beneficiado"
                  item-text="name"
                  return-object
                ></v-select>
              </v-col>

              <v-col cols="12" md="3">
                <v-autocomplete
                  :disabled="!typeId"
                  v-model="transhipmentOrDelivererId"
                  :items="transhipmentsOrDirectDeliverers"
                  item-text="name"
                  item-value="aspNetUserId"
                  :label="paymentUserTypeLabel"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="isDischarge"
                  label="Categoria"
                  :items="categoryItems"
                  no-data-text="Nenhuma categoria encontrada"
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-combobox
                  v-model="boardingNumbers"
                  :search-input.sync="boardingNumbersInput"
                  append-icon=""
                  label="Número do embarque externo"
                  hide-selected
                  multiple
                  chips
                  deletable-chips
                  @keydown.native="filterInput"
                  @change="saveBoardingNumbers"
                ></v-combobox>
              </v-col>

              <v-col cols="12" md="12" class="d-flex justify-end align-center">
                <v-btn @click="cleanFilter()" :disabled="!hasFilters" elevation="2" color="red" class="mx-2 text-white">
                  Limpar Filtros
                </v-btn>
                <v-btn
                  @click="search()"
                  :loading="loading"
                  :disabled="!hasFilters"
                  elevation="2"
                  color="green"
                  class="text-white"
                >
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table
        class="mt30 px-5"
        :loading="loading"
        :headers="columnOptions"
        :items="paymentOrders"
        :items-per-page="pageSize"
        @update:items-per-page="changeItemsPerPage"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 50],
          itemsPerPageText: 'Itens por página'
        }"
        no-data-text="Nenhum resultado encontrado"
      >
        <template #[`item.isDischarge`]="{ item }">
          <span>{{ getIsDischarge(item.isDischarge) }}</span>
        </template>
        <template #[`item.boardingNumber`]="{ item }">
          <copy-to-clipboard-tooltip :text="item.boardingNumber" />
        </template>
        <template #[`item.totalValue`]="{ item }">
          <span>{{ formatMoney(item.totalValue) }}</span>
        </template>
        <template #[`item.actions`]="{ item }">
          <div class="d-flex">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  style="font-size: 24px; position: relative; top: -6px"
                  color="black"
                  dense
                  large
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-menu
                </v-icon>
              </template>
              <v-list v-if="item.status === 'Pago'">
                <v-list-item
                  v-for="(itemDrop, indexDropdown) in itemsDropdown2"
                  :key="indexDropdown"
                  @click="actionsDropdown2(item, indexDropdown)"
                >
                  <v-list-item-title>{{ itemDrop.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
              <v-list v-else>
                <v-list-item
                  v-for="(itemDrop, indexDropdown) in itemsDropdown"
                  :key="indexDropdown"
                  @click="actionsDropdown(item, indexDropdown)"
                >
                  <v-list-item-title>{{ itemDrop.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <v-pagination
        v-model="pageNumber"
        :length="totalPages"
        @input="changePageNumber"
        :total-visible="7"
      ></v-pagination>
    </v-card>

    <v-dialog v-model="paymentDialog" persistent max-width="500">
      <v-card class="align-center">
        <v-card-title>
          <div class="d-flex align-center justify-space-between w-100">
            <div />
            <h1 class="text-center">{{ paymentDialogTitle }}</h1>
            <v-btn icon @click="paymentDialog = false" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="mt-4 text-center">
          <span>Insira o número de pagamento / transferência para concluir a ação</span>
          <v-row class="mt-5 d-flex justify-center mx-auto">
            <v-col cols="12">
              <v-text-field v-model="paymentNumber" label="N° Pagamento"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-5 d-flex justify-center mx-auto">
            <v-col cols="12">
              <v-menu
                ref="menu"
                v-model="menu7"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedPayDay"
                    label="Data de pagamento"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="payDay" :active-picker.sync="activePicker7" locale="pt-br"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="mt-5 d-flex justify-center mx-auto">
            <v-col cols="12">
              <v-textarea v-model="paymentObservation" label="Observação"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex pb-4 px-5">
          <v-btn class="flex-grow-1" color="error" large @click="paymentDialog = false"> Cancelar </v-btn>
          <v-btn class="flex-grow-1" color="success" large @click="savePayment" :disabled="!payDay"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTrash" persistent max-width="450">
      <v-card class="align-center text-center">
        <v-card-title class="headline justify-center"> Desfazer ordem de pagamento? </v-card-title>
        <v-card-text> Você confirma estar desfazendo esta ordem de pagamento </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" @click="dialogTrash = false"> Cancelar </v-btn>
          <v-btn color="success" class="flex-grow-1" @click="deleteItem()"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="detailsDialog" persistent max-width="1200">
      <v-card class="align-center" v-if="paymentOrderDetails">
        <v-card-text>
          <div class="d-flex justify-space-between align-center">
            <h1 class="py-5 text-left">
              Detalhes da ordem de pagamento - {{ isPaymentOrderDischarge ? 'Quitação' : 'Adiantamento' }}
            </h1>
            <v-btn icon @click="closeDetailsDialog()">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>

          <v-row class="mt-1 payment-order-info">
            <v-col cols="12" md="4">
              <p class="mb-2">Data de criação</p>
              <span>{{ transformDate(paymentOrderDetails.createdAt) }}</span>
            </v-col>
            <v-col cols="6" md="4">
              <p class="mb-2">Previsão de Pagamento</p>
              <span>{{ transformDate(paymentOrderDetails.paymentForecast) }}</span>
            </v-col>
            <v-col cols="6" md="4">
              <p class="mb-2">Data de pagamento</p>
              <span>{{ paymentOrderDetails.payDay ? transformDate(paymentOrderDetails.payDay) : '-' }}</span>
            </v-col>
            <v-col cols="12" md="4">
              <p class="mb-2">{{ paymentOrderDetails.type }}</p>
              <span>{{ paymentOrderDetails.name }}</span>
            </v-col>

            <v-col cols="12" md="4">
              <p class="mb-2">Referência da Ordem de Pagamento</p>
              <span>{{ paymentOrderDetails.paymentReceiptNumber }}</span>
            </v-col>

            <v-col cols="12" md="4">
              <p class="mb-2">Observação</p>
              <span>{{ paymentOrderDetails.observation ? paymentOrderDetails.observation : 'Sem observações' }}</span>
            </v-col>
          </v-row>

          <h1 class="mt-6 text-left">Descrição de Entradas</h1>
          <v-row>
            <v-col cols="12">
              <div class="table mt-10 px-0">
                <v-data-table
                  v-if="paymentOrderDetails.type === 'Transbordo'"
                  :headers="columnsTranschipmentsOptions2"
                  :items="paymentOrderDetails.descriptionOfEntries"
                  :items-per-page="paymentOrderDetails.descriptionOfEntries.length"
                  hide-default-footer
                  fixed-header
                  :height="entriesTableHeight"
                >
                  <template v-slot:[`item.price`]="{ item }">
                    {{ transformPrice(item.price) }}
                  </template>
                  <template v-slot:[`item.createdAt`]="{ item }">
                    {{ transformDate(item.createdAt) }}
                  </template>
                </v-data-table>
                <v-data-table
                  v-else
                  :headers="columnsShipmentOptions2"
                  :items="paymentOrderDetails.descriptionOfEntries"
                  :items-per-page="paymentOrderDetails.descriptionOfEntries.length"
                  hide-default-footer
                  fixed-header
                  :height="entriesTableHeight"
                >
                  <template v-slot:[`item.advanceAmount`]="{ item }">
                    {{ transformPrice(item.advanceAmount) }}
                  </template>
                  <template v-slot:[`item.price`]="{ item }">
                    {{ transformPrice(item.price) }}
                  </template>
                  <template v-slot:[`item.createdAt`]="{ item }">
                    {{ transformDate(item.createdAt) }}
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>

          <h1 class="mt-6 text-left">Descrição de Adicionais</h1>
          <v-row>
            <v-col cols="12">
              <div class="table mt-10 mb-5 px-0">
                <v-data-table
                  v-if="paymentOrderDetails.type === 'Transbordo'"
                  :headers="columnsTranschipmentsOptions3"
                  :items="paymentOrderDetails.descriptionOfAdditionals"
                  :items-per-page="paymentOrderDetails.descriptionOfAdditionals.length"
                  fixed-header
                  :height="aditionalsTableHeight"
                  hide-default-footer
                >
                  <template v-slot:[`item.id`]="{ item }">
                    {{ getAditionalId(item.id) }}
                  </template>
                  <template v-slot:[`item.price`]="{ item }">
                    {{ transformPrice(item.price) }}
                  </template>
                  <template v-slot:[`item.isDiscount`]="{ item }">
                    {{ transformDiscount(item.isDiscount) }}
                  </template>
                  <template v-slot:[`item.obs`]="{ item }">
                    <TruncateDataWithTooltip :data="item.obs" :lengthDataToTruncate="40"></TruncateDataWithTooltip>
                  </template>
                </v-data-table>
                <v-data-table
                  v-else
                  :headers="columnsShipmentsOptions3"
                  :items="paymentOrderDetails.descriptionOfAdditionals"
                  :items-per-page="paymentOrderDetails.descriptionOfAdditionals.length"
                  hide-default-footer
                >
                  <template v-slot:[`item.price`]="{ item }">
                    {{ transformPrice(item.price) }}
                  </template>
                  <template v-slot:[`item.isDiscount`]="{ item }">
                    {{ transformDiscount(item.isDiscount) }}
                  </template>
                  <template v-slot:[`item.obs`]="{ item }">
                    <TruncateDataWithTooltip :data="item.obs" :lengthDataToTruncate="40"></TruncateDataWithTooltip>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="d-flex justify-space-around mx-12">
              <div class="d-flex money-cards">
                <div class="circle">
                  <v-icon class="pa-3" large color="white"> mdi-cash-minus </v-icon>
                </div>
                <span class="d-flex px-2 flex-column justify-center"
                  >TOTAL DE DÉBITOS
                  <strong>{{ transformPrice(paymentDiscount) }}</strong>
                </span>
              </div>
              <div class="d-flex money-cards">
                <div class="circle">
                  <v-icon class="pa-3" large color="white"> mdi-cash-plus </v-icon>
                </div>
                <span class="d-flex px-2 flex-column justify-center"
                  >TOTAL DE CRÉDITOS
                  <strong> {{ transformPrice(paymentValue) }}</strong>
                </span>
              </div>
              <div class="d-flex money-cards">
                <div class="circle">
                  <v-icon class="pa-3" large color="white"> mdi-cash-register </v-icon>
                </div>
                <span class="d-flex px-2 flex-column justify-center"
                  >TOTAL DA ORDEM
                  <strong>
                    {{ transformPrice(paymentValue - paymentDiscount) }}
                  </strong>
                </span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center py-5">
          <v-btn color="error" class="mx-2 px-5" large @click="closeDetailsDialog"> Cancelar </v-btn>
          <v-btn color="success" class="mx-2 px-5" large @click="(detailsDialog = false), (paymentDialog = true)">
            {{ paymentOrderDetails.payDay ? 'Editar' : 'Pagar' }}
          </v-btn>
          <v-btn
            v-if="paymentOrderDetails.paymentReceiptNumber === null"
            color="primary"
            class="mx-2 px-5"
            large
            @click="(detailsDialog = false), (dialogTrash = true)"
          >
            Desfazer
          </v-btn>
          <v-btn
            v-if="paymentOrderDetails.paymentReceiptNumber != null"
            color="indigo"
            class="mx-2 px-5"
            large
            outlined
            @click="getPDF()"
          >
            Imprimir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BreadCrumb from '../../../components/BreadCrumb.vue';
import maskData from '../../../utils/maskData';
import maskPrice from '../../../utils/maskPrice';
import MessagesError from '../../../components/MessagesError.vue';
import TruncateDataWithTooltip from '../../../components/Table/TruncateDataWithTooltip.vue';
import { toISODate } from '@/handlers/DateHandler';
import CopyToClipboardTooltip from '@/components/CopyToClipboardTooltip.vue';
import comboboxFormatter from '@/utils/comboboxFormatter';
import allowedChars from '@/utils/allowedChars';

export default {
  name: 'AccountsPayablePaymentOrders',
  components: {
    BreadCrumb,
    MessagesError,
    TruncateDataWithTooltip,
    CopyToClipboardTooltip
  },
  data: () => ({
    isExportButtonLoading: false,
    totalRecords: 0,
    initialCreatedAt: null,
    initialCreatedAtMenu: false,
    endCreatedAt: null,
    endCreatedAtMenu: false,
    initialForecast: null,
    initialForecastMenu: false,
    endForecast: null,
    endForecastMenu: false,
    initialPayment: null,
    initialPaymentMenu: false,
    endPayment: null,
    endPaymentMenu: false,
    statusId: null,
    paymentUserTypes: {
      DIRECT_DELIVERER: 'Entregador Direto',
      TRANSHIPMENT: 'Transbordo'
    },
    boardingNumbers: [],
    boardingNumbersInput: '',
    transhipmentOrDelivererId: null,
    transhipmentsOrDirectDeliverers: [],
    transhipmentsUsers: [],
    directDeliverersUsers: [],
    isDischarge: null,
    categoryItems: [
      { text: 'Quitação', value: true },
      { text: 'Adiantamento', value: false }
    ],
    pageNumber: 1,
    pageSize: 10,
    totalPages: 0,

    itemsDropdown: [{ title: 'Pagar' }, { title: 'Desfazer' }, { title: 'Ver detalhes' }],
    itemsDropdown2: [{ title: 'Editar' }, { title: 'Ver detalhes' }, { title: 'Imprimir Fatura' }],
    selected: [],
    selectedCheckbox: [],
    selectedTranshipment: {
      children: [],
      data: { name: '' }
    },
    selectedNewShipment: [],
    aditionalType: ['Adicional', 'Desconto'],
    columns: ['name'],
    columnsTranshipments: ['id', 'date', 'price'],
    columnsTranschipmentsOptions2: [
      {
        value: 'id',
        text: 'ID PARADAS CONCLUÍDAS'
      },
      {
        value: 'boardingNumber',
        text: 'EMBARQUES EXTERNOS'
      },
      {
        value: 'numbers',
        text: 'NÚMEROS DE CTES'
      },
      {
        value: 'createdAt',
        text: 'DATA DE CRIAÇÃO'
      },
      {
        value: 'price',
        text: 'VALOR TOTAL'
      }
    ],
    columnsShipmentOptions2: [
      {
        value: 'id',
        text: 'ID EMBARQUES CONCLUÍDOS'
      },
      {
        value: 'numbers',
        text: 'EMBARQUES EXTERNOS'
      },
      {
        value: 'createdAt',
        text: 'DATA DE CRIAÇÃO'
      },
      {
        value: 'advanceAmount',
        text: 'ADIANTAMENTO'
      },
      {
        value: 'price',
        text: 'VALOR DO FRETE'
      }
    ],
    columnsTranschipmentsOptions3: [
      {
        value: 'id',
        text: 'ID PARADAS CONCLUÍDAS'
      },
      {
        value: 'isDiscount',
        text: 'TIPO'
      },
      {
        value: 'price',
        text: 'VALOR'
      },
      {
        value: 'justification',
        text: 'JUSTIFICATIVA'
      },
      {
        value: 'obs',
        text: 'OBSERVAÇÃO'
      }
    ],
    columnsShipmentsOptions3: [
      {
        value: 'id',
        text: 'ID EMBARQUES CONCLUÍDOS'
      },
      {
        value: 'isDiscount',
        text: 'TIPO'
      },
      {
        value: 'price',
        text: 'VALOR'
      },
      {
        value: 'justification',
        text: 'JUSTIFICATIVA'
      },
      {
        value: 'obs',
        text: 'OBSERVAÇÃO'
      }
    ],
    payDay: null,
    paymentForecast: null,
    menu7: false,
    typeId: null,
    activePicker7: null,
    errors: [],
    error500: null,
    errorsType: 'error',
    loading: true,
    paymentDialog: false,
    detailsDialog: false,
    dialog: false,
    dialogTrash: false,
    paymentNumber: null,
    paymentObservation: null,
    selectedItem: null,
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Financeiro',
        disabled: true,
        to: '/couriers-accounts-payable/'
      },
      {
        text: 'Ordens de Pagamento',
        disabled: true,
        to: '/payment-orders/'
      }
    ],
    columnOptions: [
      {
        value: 'name',
        text: 'NOME'
      },
      {
        value: 'paymentForecast',
        text: 'PREVISÂO DE PAGAMENTO'
      },
      {
        value: 'payDay',
        text: 'PAGAMENTO REALIZADO'
      },
      {
        value: 'boardingNumber',
        text: 'EMBARQUES EXTERNOS'
      },
      {
        value: 'type',
        text: 'BENEFICIADO'
      },
      {
        value: 'isDischarge',
        text: 'CATEGORIA'
      },
      {
        value: 'status',
        text: 'STATUS'
      },
      {
        value: 'totalValue',
        text: 'VALOR TOTAL'
      },
      {
        value: 'actions',
        text: 'AÇÕES',
        sortable: false
      }
    ],
    paymentOrders: [],
    paymentOrderDetails: null
  }),
  computed: {
    ...mapGetters('ShipmentStore', ['getManegementShipments']),
    ...mapGetters('AccountsStore', ['getPaymentOrderDetail', 'getSummaryTypes', 'getSummaryStatus']),

    paymentDialogTitle() {
      const hasPayDay = this.selectedItem ? this.selectedItem.payDay !== null : false;
      return hasPayDay ? 'Editar pagamento' : 'Realizar pagamento';
    },

    formattedPayDay() {
      if (!this.payDay) return null;
      const [year, month, day] = this.payDay.split('-');
      return `${day}/${month}/${year}`;
    },
    paymentDiscount() {
      const value = this.paymentOrderDetails.descriptionOfAdditionals
        .map((item) => {
          return item.isDiscount ? item.price : 0;
        })
        .reduce((total, price) => (total += price), 0);
      return value;
    },
    paymentValue() {
      const value = this.paymentOrderDetails.descriptionOfEntries
        .map((item) => {
          if (this.isPaymentOrderDischarge) {
            return item.price - item.advanceAmount;
          } else {
            return item.advanceAmount;
          }
        })
        .reduce((total, price) => (total += price), 0);
      const value2 = this.paymentOrderDetails.descriptionOfAdditionals
        .map((item) => {
          return !item.isDiscount ? item.price : 0;
        })
        .reduce((total, price) => (total += price), 0);
      return value + value2;
    },
    hasFilters() {
      return (
        this.initialCreatedAt !== null ||
        this.endCreatedAt !== null ||
        this.initialForecast !== null ||
        this.endForecast !== null ||
        this.initialPayment !== null ||
        this.endPayment !== null ||
        this.statusId !== null ||
        this.typeId !== null ||
        this.transhipmentOrDelivererId !== null ||
        this.isDischarge !== null ||
        this.boardingNumbers.length
      );
    },
    formattedInitialCreatedAt() {
      let date = this.initialCreatedAt;
      return this.formatDate(date);
    },
    formattedEndCreatedAt() {
      let date = this.endCreatedAt;
      return this.formatDate(date);
    },
    formattedInitialForecast() {
      let date = this.initialForecast;
      return this.formatDate(date);
    },
    formattedEndForecast() {
      let date = this.endForecast;
      return this.formatDate(date);
    },
    formattedInitialPayment() {
      let date = this.initialPayment;
      return this.formatDate(date);
    },
    formattedEndPayment() {
      let date = this.endPayment;
      return this.formatDate(date);
    },
    paymentUserTypeLabel() {
      if (this.typeId) {
        return this.typeId.name === 'Transbordo' ? 'Transbordo' : 'Entregador direto';
      } else return 'Selecione um beneficiado';
    },
    isPaymentOrderDischarge() {
      return this.paymentOrderDetails.isDischarge;
    },
    entriesTableHeight() {
      const hasMoreThanFiveEntries = this.paymentOrderDetails.descriptionOfEntries.length > 5;
      return hasMoreThanFiveEntries ? '350' : '';
    },
    aditionalsTableHeight() {
      const hasMoreThanFiveAditional = this.paymentOrderDetails.descriptionOfAdditionals.length > 10;
      return hasMoreThanFiveAditional ? '350' : '';
    },

    getTheLastThirtyDays() {
      const now = new Date();
      const currentDay = now;
      const thirtyDayAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);

      return {
        thirtyDayAgo: thirtyDayAgo.toISOString().slice(0, 10),
        currentDay: currentDay.toISOString().slice(0, 10)
      };
    }
  },

  watch: {
    typeId: {
      async handler(value) {
        if (value !== null) {
          this.transhipmentOrDelivererId = null;
          const { name: userType } = value;
          const hasDirectDeliverersUsers = this.directDeliverersUsers.length !== 0;
          const hasTranshipmentsUsers = this.transhipmentsUsers.length !== 0;

          if (userType === this.paymentUserTypes.DIRECT_DELIVERER) {
            if (!hasDirectDeliverersUsers) {
              await this.fetchDirectDeliverersUsers();
            }
            this.transhipmentsOrDirectDeliverers = this.directDeliverersUsers;
          } else {
            if (!hasTranshipmentsUsers) {
              await this.fetchTranshipmentsUsers();
            }
            this.transhipmentsOrDirectDeliverers = this.transhipmentsUsers;
          }
        }
      }
    }
  },

  mounted() {
    this.filterTheLastThirtyDays();
    this.fetchAllPaymentOrders();
    this.fetchAllSummaryData();
  },
  methods: {
    ...mapActions('AccountsStore', [
      'fetchTranshipment',
      'fetchPaymentOrders',
      'payPaymentOrder',
      'undoPaymentOrder',
      'getPaymentOrderDetails',
      'getSummaryTypePaymentOrder',
      'getSummaryStatusPaymentOrder',
      'getDirectDeliverersForPaymentOrder',
      'getTranshipmentForPaymentOrder',
      'getPaymentOrderPDF',
      'exportPaymentOrderSheet'
    ]),

    async fetchDirectDeliverersUsers() {
      try {
        this.directDeliverersUsers = await this.getDirectDeliverersForPaymentOrder();
      } catch (error) {
        console.error(error);
      }
    },
    async fetchTranshipmentsUsers() {
      try {
        this.transhipmentsUsers = await this.getTranshipmentForPaymentOrder();
      } catch (error) {
        console.error(error);
      }
    },
    filterTheLastThirtyDays() {
      const { thirtyDayAgo, currentDay } = this.getTheLastThirtyDays;
      this.initialCreatedAt = thirtyDayAgo;
      this.endCreatedAt = currentDay;
    },
    getAditionalId(id) {
      return id != '00000000-0000-0000-0000-000000000000' ? id : '-';
    },
    getFilters() {
      const {
        initialCreatedAt,
        endCreatedAt,
        initialForecast,
        endForecast,
        initialPayment,
        endPayment,
        statusId,
        typeId,
        transhipmentOrDelivererId,
        isDischarge,
        boardingNumbers
      } = this;

      return {
        initialCreatedAt,
        endCreatedAt,
        initialForecast,
        endForecast,
        initialPayment,
        endPayment,
        statusId,
        typeId,
        transhipmentOrDelivererId,
        isDischarge,
        boardingNumbers
      };
    },
    formatDate(d) {
      if (d === null) return d;
      let dateObj = new Date(`${d}T00:00:00`);
      return dateObj.toLocaleDateString('pt-BR');
    },
    getIsDischarge(isDischarge) {
      return isDischarge ? 'Quitação' : 'Adiantamento';
    },
    search() {
      this.pageNumber = 1;
      this.fetchAllPaymentOrders();
    },
    transformDateToISOString(date) {
      this.$refs.menu.save(date);
      const partOfDate = date.split('-');
      const newDate = new Date(partOfDate[0], partOfDate[1] - 1, partOfDate[2]);
      return newDate.toISOString();
    },
    filterInput(event) {
      return allowedChars(event, /[0-9,.;/]/);
    },
    saveBoardingNumbers(value) {
      this.boardingNumbers = comboboxFormatter(value);
    },
    cleanFilter() {
      this.initialCreatedAt = null;
      this.endCreatedAt = null;
      this.initialForecast = null;
      this.endForecast = null;
      this.initialPayment = null;
      this.endPayment = null;
      this.statusId = null;
      this.typeId = null;
      this.transhipmentOrDelivererId = null;
      this.isDischarge = null;
      this.boardingNumbers = [];

      this.fetchAllPaymentOrders();
    },
    async fetchAllSummaryData() {
      this.loading = true;
      try {
        await this.getSummaryTypePaymentOrder();
        await this.getSummaryStatusPaymentOrder();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    transformDate(date) {
      return maskData(date);
    },
    transformPrice(price) {
      return maskPrice(price);
    },
    transformDiscount(discount) {
      return discount ? 'Débito' : 'Crédito';
    },
    actionsDropdown(item, index) {
      this.selectedItem = item;
      this.payDay = item.payDay;
      this.paymentNumber = item.paymentReceiptNumber;
      this.paymentObservation = item.observation;
      if (index == 0) {
        this.paymentDialog = true;
      }
      if (index == 1) {
        this.dialogTrash = true;
      }
      if (index == 2) {
        this.openPaymentOrderDetails();
        this.detailsDialog = true;
      }
    },
    actionsDropdown2(item, index) {
      this.selectedItem = item;
      this.payDay = toISODate(item.payDay);
      this.paymentNumber = item.paymentReceiptNumber;
      this.paymentObservation = item.observation;
      if (index == 0) {
        this.paymentDialog = true;
      }
      if (index == 1) {
        this.openPaymentOrderDetails();
        this.detailsDialog = true;
      }
      if (index == 2) {
        this.getPDF();
      }
    },

    removeFromSelectedTranshipments(key) {
      this.selectedCheckbox = this.selectedCheckbox.filter((item) => {
        return item.key !== key;
      });
    },
    async fetchAllPaymentOrders() {
      const { pageNumber, pageSize } = this;
      const filters = this.getFilters();
      this.loading = true;
      try {
        const { data, totalPages, totalRecords } = await this.fetchPaymentOrders({ pageNumber, pageSize, ...filters });
        this.totalPages = totalPages;
        this.totalRecords = totalRecords;
        const payments = data.map((item) => {
          return {
            ...item,
            createdAt: this.transformDate(item.createdAt),
            paymentForecast: this.transformDate(item.paymentForecast),
            payDay: item.payDay != null ? this.transformDate(item.payDay) : item.payDay,
            paymentMade: item.status === 'Pago' ? this.transformDate(item.createdAt) : item.createdAt,
            boardingNumber: item.boardingNumber.join(', ')
          };
        });
        this.paymentOrders = payments;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    changePageNumber(pageNumber) {
      this.pageNumber = pageNumber;
      this.fetchAllPaymentOrders();
    },
    changeItemsPerPage(pageSize) {
      this.pageSize = pageSize;
      this.fetchAllPaymentOrders();
    },
    async savePayment() {
      const model = {
        idPaymentOrder: this.selectedItem.id,
        paymentOrderReference: this.paymentNumber,
        payDay: this.payDay,
        observation: this.paymentObservation
      };

      try {
        const data = await this.payPaymentOrder(model);

        if (data.success) {
          this.errors = this.selectedItem.payDay
            ? ['Pagamento editado com sucesso!']
            : ['Pagamento registrado com sucesso!'];
          this.errorsType = 'success';
        } else {
          this.errors = ['Erro ao salvar pagamento!'];
          this.errorsType = 'error';
          this.error500 = data;
        }
      } catch (e) {
        console.error(e);
        this.errors = ['Opss, algo deu errado!'];
        this.errorsType = 'error';
      } finally {
        this.paymentDialog = false;
        this.paymentNumber = null;
        this.selectedItem = null;
        this.fetchAllPaymentOrders();
      }
    },
    async deleteItem() {
      try {
        const data = await this.undoPaymentOrder(this.selectedItem.id);

        if (data.success) {
          this.errors = ['Ordem de pagamento desfeita com sucesso!'];
          this.errorsType = 'success';
        } else {
          this.errors = ['Erro ao desfazer ordem de pagamento!'];
          this.errorsType = 'error';
          this.error500 = data;
        }
      } catch (e) {
        console.error(e);
        this.errors = ['Opss, algo deu errado!'];
        this.errorsType = 'error';
      } finally {
        this.dialogTrash = false;
        this.selectedItem = null;
        this.fetchAllPaymentOrders();
      }
    },
    async openPaymentOrderDetails() {
      try {
        const data = await this.getPaymentOrderDetails(this.selectedItem.id);
        this.paymentOrderDetails = this.getPaymentOrderDetail;

        if (data.status === '500') {
          this.errors = ['Erro ao desfazer ordem de pagamento!'];
          this.errorsType = 'error';
          this.error500 = data;
        }
      } catch (e) {
        console.error(e);
        this.errors = ['Opss, algo deu errado!'];
        this.errorsType = 'error';
      }
    },
    closeDetailsDialog() {
      this.detailsDialog = false;
      this.selectedItem = null;
    },
    async getPDF() {
      try {
        await this.getPaymentOrderPDF(this.selectedItem.id);
      } catch (err) {
        this.errors = ['Ops, algo deu errado'];
        this.errorsType = 'error';
      }
    },
    async handleExport() {
      try {
        this.isExportButtonLoading = true;
        await this.fetchAllPaymentOrders();
        const filters = this.getFilters();
        const data = await this.exportPaymentOrderSheet({ ...filters, pageSize: this.totalRecords });
        if (data.success) {
          this.errors = ['Planilha exportada com sucesso!'];
          this.errorsType = 'success';
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isExportButtonLoading = false;
      }
    },
    formatMoney(money) {
      return money.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL'
      });
    }
  }
};
</script>
<style scoped lang="scss">
.panel-header {
  background: $--color-table-offset;
}
.payment-order-info {
  p {
    color: $--color-primary;
  }
}
.money-cards {
  padding: 10px 28px;
  border-radius: 5px;
  background: #1f77b4;
  color: white;
  span {
    font-size: 0.8rem;
    strong {
      font-size: 1.3rem;
      font-weight: 600;
    }
  }
  .circle {
    background: #1f77b4;
    border: solid 1px white;
    border-radius: 100%;
    padding: 0px;
  }
}
::v-deep.v-select.v-select--chips .v-select__selections {
  min-height: 50px;
}
::v-deep .v-data-table-header tr th {
  background-color: #e0e0e0 !important;
  border: 1px solid #e0e0e0;
}
</style>
